export var HEADER_VALUE = {
  'set-edgescape-cookie': true
};
export var cookieConstants = {
  COOKIE_NAME: 'geoloc',
  COUNTRY_KEY: 'cc'
};
export var convenienceKeys = {
  queryParam: 'geolocCountry',
  ccAlias: 'country'
};
export var defaultMarketplace = 'US';
export var countryRegex = /^[a-zA-Z]{2}$/; // Examples of matches:
// /ch/it
// /jp
// /mx/t/shoes
// See https://confluence.nike.com/display/CICSEO/CIC+URL+Layout for expected URL structure.

export var marketplaceRegex = /^\/([a-z]{2})(?:\/|$)/;
/**
 * @memberof ux-tread-geoloc
 * @description the object parsed from the geoloc cookie set by Akamai
 * @typedef {object} GeoLocObject
 * @property {string} cc - country code
 * @property {string} rc - region code
 * @property {string} tz - timezone
 * @property {string} la - latitude
 * @property {string} lo - longitude
 * @property {string} tp - throughput
 */